import React, { Fragment } from 'react';
import { ACTION_TYPE } from '../types';
import * as S from './styles';
export const BottomSection = ({ actionItems, headerType }) => (React.createElement(S.Wrapper, { "$type": headerType }, actionItems.map(({ id, title, href, type, callback }) => {
    const props = {};
    if (href) {
        props.href = href;
    }
    return (React.createElement(Fragment, { key: id }, type === ACTION_TYPE.Login ? (React.createElement(S.CustomLink, Object.assign({}, props, { underline: "none" }), title)) : (React.createElement(S.RegistrationLink, Object.assign({}, props, { underline: "none", onClick: callback ? callback : undefined }), title))));
})));
//# sourceMappingURL=index.js.map